module.exports = __webpack_public_path__ + "img/noticias.95f27fb0.png";